import templateStr from 'text!./mobile-quote-offerings.html';
import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './MobileQuoteOfferings-hashed.scss';
import controller from './MobileQuoteOfferingsCtrl';

export default {
    template: cssUtil.hashTemplate(templateStr, styles),
    bindings: {
        submission: '<',
        isPaymentPeriodMonthly: '=',
        offeringUtilFunctions: '<',
        lobCode: '&'
    },
    controller: ['$filter', function ($filter) {
        this.$onInit = () => controller.call(this, $filter); 
    }]
};
